import React, { PureComponent } from 'react';
import { Field } from 'redux-form';
import { Editor } from '../index';

class AboutUs extends PureComponent {

  render() {
    return (
      <div className="planet-about-us">
        <Field
          name="us"
          component={Editor}/>
      </div>
    );
  }
}

AboutUs.propTypes = {};
AboutUs.defaultProps = {};

export default AboutUs;



// WEBPACK FOOTER //
// ./src/components/about-us/AboutUs.js